/**
 * Deterministic avatar color + initials for result cards.
 *
 * Shared by the email, contact, and events cards so the same person hashes to
 * the same color and initials across every card type. (The richer
 * `modules/shared/colors.ts` family can't be used here — `features/` must not
 * import `modules/` per the one-way import rules — so this is the features-side
 * equivalent.)
 */

// Blue family only — blue is the brand color; rails/avatars vary in tone for
// distinguishability but never stray into green/earth hues.
export const PALETTE = ['#15a5e3', '#0c6c93', '#3a6ea5', '#5b8fb0', '#2a5d9f', '#7aa7c7', '#1b4965', '#4f86c6'];

/** Stable color for a seed string (email/name), picked from {@link PALETTE}. */
export function hueFor(seed: string): string {
  let h = 0;
  for (const c of seed) h = (h * 31 + c.charCodeAt(0)) >>> 0;
  return PALETTE[h % PALETTE.length];
}

/** 1–2 letter initials from a name (preferred) or email local-part. */
export function initials(name: string | undefined, email: string): string {
  const base = (name || email || '?').trim();
  const parts = base.split(/[\s._-]+/).filter(Boolean);
  return (parts.length >= 2 ? parts[0][0] + parts[1][0] : base.slice(0, 2)).toUpperCase();
}
